import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretLeft, faSave, faCaretRight, faFilePdf, faFileWord, faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import $ from 'jquery';
import _ from 'lodash';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import 'bootstrap/dist/css/bootstrap.css';
import Axios from 'axios';
import { Alert, Logout, BaseURL, DConnect, DecryptData, PostOptions } from '../../components/Config'

function Shareholder(props) {
    const [businessDetails, setBusinessDetails] = useState(props.businessDetails);
    const [registration, setRegistration] = useState(props.registration);
    const [position, setPosition] = useState(props.position);
    const [dropdowns, setDropdowns] = useState({'gender':[], 'nationality':[]});
    const [shareData, setShareData] = useState({id:0, app_num:props.businessDetails.app_num, name:'', ghcardnum:'', gender:0, share:0, idcardimage:'', nationality: 0, createdon:new Date(), modifiedon:new Date(), modifiedby:''});
    const [shareholdings, setShareholdings] = useState(props.shareholdings);
    const [shareholdids, setShareholdIds] = useState([]);
    const [image, setImage] = useState([]);
    const [index, setIndex] = useState(-1);
    const [save, setSave] = useState(false);
    const [count, setCount] = useState(0);
    const [modalstatus , setModalStatus] =  useState(false);
    const [doc1, setDoc1] = useState({document:'', fileUrl:'', ex:''});
    const [doc2, setDoc2] = useState({document:'', fileUrl:'', ex:''});

    const curformat = new Intl.NumberFormat("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    useEffect(() => {
        props.getProps(props);
        setBusinessDetails(props.businessDetails);
        setShareholdings(props.shareholdings);
        setDropdowns(props.dropdowns);

        getShareholders();
    }, []);

    const getShareholders = () => {
          let resdata = shareholdings
            
            let queryData = {
                data: `SELECT app_num, ghcardnum FROM shareholding`
                };
        
           Axios(PostOptions("POST", queryData, "registration/squery"))
             .then((res) => {
               let rdata = DecryptData(res.data);
               setShareholdIds(rdata)
             })
            if(resdata.length > 0){
                setShareholdings(resdata);
                let max = 0;
                let count = 0;
                resdata.map(row =>{
                    if(parseFloat(row.share) >= max){
                    max = row.share;
                    }
                })
                resdata.map(row =>{
                    if(parseFloat(row.share) == max){
                    count++;
                    }
                })
                setCount(count);
            }
    }

    const handleShares = (e) => {
        e.preventDefault();

        const { name, value } = e.target;

        if(['share'].includes(name)){
            let nValue = (value < 0) ? 0 : parseFloat(value);
            setShareData(prevState => ({ ...prevState, [name]: nValue }));
        }else if(['ghcardnum'].includes(name)){
            setShareData(prevState => ({ ...prevState, [name]: value.trim() }));
        }else{
            setShareData(prevState => ({ ...prevState, [name]: value }));
        }
    };

    const CardDuplicateCheck = (e, appnum) => {
        const { name, value } = e.target;
        let data = shareholdids.filter(row => row.ghcardnum == value)
        let invalid = false;
     
        if(value != null && value.length == 15){
            if(value.charAt(3) == '-' && value.charAt(13)== '-'){
                if((/[a-zA-Z]/).test(value.charAt(0)) && (/[a-zA-Z]/).test(value.charAt(1)) && (/[a-zA-Z]/).test(value.charAt(2))){
                    if((/^\d+$/).test(value.substr(4, 9)) && value.substr(4, 9).length == 9){
                        if(!(/^[a-zA-Z0-9]+$/).test(value.charAt(value.length-1))){
                           invalid = true;
                        }
                    }else{
                        invalid = true;
                    }   
                }else{
                    invalid = true;
                }
            }else{
                invalid = true;
            }
        }else{
            invalid = true;
        } 
        if(data.length > 0 || invalid){
            setShareData(prevState => ({ ...prevState, [name]: '' }));
        }
    }

    const submitForm = (e) => {
        e.preventDefault();

        if(shareholdings.length === 0){
            Alert({title:'Shareholder Details',message:'Please enter shareholder details...', buttons:[{label:'Ok'}]});
            return;
        }else if(_.sumBy(shareholdings, 'share') !== 100){
            Alert({title:'Shareholder Details',message:'Please Shareholder percentage must add up to 100%...', buttons:[{label:'Ok'}]});
            return;
        }

        if(businessDetails.idcard1image == '' || businessDetails.idcard1image == null){
            Alert({title:'Majority Shareholder',message:"Upload Majority Shareholder's ID Card...", buttons:[{label:'Ok'}]});
            return;
        }

        if(count == 2 && (businessDetails.idcard2image == '' || businessDetails.idcard2image == null)){
            Alert({title:'Majority Shareholder',message:"Upload Second Majority Shareholder's ID Card...", buttons:[{label:'Ok'}]});
            return;
        }

        props.handleChange(0, businessDetails);
        let options = (businessDetails.id == 0) ? PostOptions('POST', businessDetails, 'business')
            : PostOptions('PUT', businessDetails, `business/${businessDetails.id}`);
        
        Axios(options).then(res => {
            let resdata = DecryptData(res.data);

            let formData1 = new FormData();
            formData1.append('filename', businessDetails.idcard1image);
            formData1.append('cert', doc1.document);
            Axios.post(`${BaseURL()}v1.0/fileupload`, formData1).then(resp => { });

            let formData2 = new FormData();
            formData2.append('filename', businessDetails.idcard2image);
            formData2.append('cert', doc2.document);
            Axios.post(`${BaseURL()}v1.0/fileupload`, formData2).then(resp => { });    

            if (resdata.id !== undefined) {
                businessDetails['id'] = resdata.id;
                props.handleChange(0, businessDetails);
            }

            position.app_num = registration.app_num;
            position.ma_stage = position.ma_stage < 3 ? 3: position.ma_stage;
            props.handleChange(14, position);
            options = (position.id == 0) ? PostOptions('POST', position, 'appstage')
            : PostOptions('PUT', position, `appstage/${position.id}`);
            Axios(options).then(resD => {
                let resData = DecryptData(resD.data); 

                if (resData.id !== undefined) {
                    position['id'] = resData.id;
                    props.handleChange(14, position);
                }
             })
        }).catch(error => { Alert({title:'Business Details',message:error.message, buttons:[{label:'Ok'}]}); });

        props.handleChange(1, shareholdings);
        
        Axios(PostOptions('POST', shareholdings, 'shareholding/bulk')).then(res => {
            let resdata = DecryptData(res.data);

            if(resdata.length > 0){
                props.handleChange(1, resdata);
            }
            
        })//.catch(error => { Alert({title:'Saving Shareholders',message:error.message, buttons:[{label:'Ok'}]}); });
        if(save){
        Logout()
        window.location.reload()
        }else{
        props.doNavigate(props,3,1);
        }
    };

    const saveShareholder = (e) => {
        e.preventDefault();
       
        let sharehldings = shareholdings;
        if(index < 0){
        sharehldings.push(shareData);
        }else{
            sharehldings[index] = shareData
        }
        let max = 0;
        let count = 0;
        sharehldings.map(row =>{
            if(parseFloat(row.share) >= max){
               max = row.share;
            }
        })
        sharehldings.map(row =>{
            if(parseFloat(row.share) == max){
               count++;
            }
        })
        setCount(count);
        setShareholdings(sharehldings);
        props.handleChange(1, sharehldings);

        hideDialog();
    }

    const fileChange = (e) => {
        e.preventDefault();

        const {name, value} = e.target;

        let reader = new FileReader();
        let file = e.target.files[0];
        let ext = file.name.split('.');
        if(['jpg','jpeg','png'].includes(ext[ext.length-1])){
        setBusinessDetails(prevState => ({...prevState, [name]:`${businessDetails.app_num}_${name}.${ext[ext.length-1]}`}));

        reader.onloadend = () => {
            let image = {document:file, fileUrl: reader.result, ext:ext[ext.length-1]};
            
            if(name === 'idcard1image'){
                setDoc1(image);
            }else if(name === 'idcard2image'){
                setDoc2(image);
            }
        }

        reader.readAsDataURL(file);
     }
    }

    const clickTrigger = (id) =>{
        $('#'+id).click();
    }

    const deleteShareholder = (idx) => {
        let newSharehohlder = [...shareholdings];

        newSharehohlder.splice(idx,1);
        let max = 0;
        let count = 0;
        newSharehohlder.map(row =>{
            if(parseFloat(row.share) >= max){
               max = row.share;
            }
        })
        newSharehohlder.map(row =>{
            if(parseFloat(row.share) == max){
               count++;
            }
        })
        setCount(count);
        setShareholdings(newSharehohlder);
        props.handleChange(1, newSharehohlder);
    }
    const editShareholder = (row, idx) => {
        setShareData(row); 
        setIndex(idx);   
        setModalStatus(true)
        
    }

    const hideDialog = () => {
        setModalStatus(false);
        setIndex(-1);
        setShareData({id:0, app_num:props.businessDetails.app_num, name:'', ghcardnum:'', gender:0, share:0, idcardimage:'', nationality: 0, createdon:new Date(), modifiedon:new Date(), modifiedby:''});
    }

    const formatGender = (cell, row) => {
        let gender = dropdowns.gender.filter(gend => gend.ivalue == cell);

        return (gender[0] !== undefined) ? gender[0].iname : cell;
    }

    const formatNationality = (cell, row) => {
        let nationality = dropdowns.nationality.filter(nat => nat.ivalue == cell);

        return (nationality[0] !== undefined) ? nationality[0].iname : cell; 
    }

    return (
        <div className="content">
            <h5>Shareholding <span>Structure</span></h5><br />
            <form id="frmShareholding" method="POST" onSubmit={submitForm}>
                <div className="row">

                    <div className='col align-self-center'>
                        <a onClick={() => setModalStatus(true)} className="btn btn-primary" style={{float:'right', marginBottom: 6}}>Add Shareholder<span className="required">*</span></a>
                        
                        <div className="clearfix"></div><hr />
                        <table className="table table-striped table-condensed d-none d-md-block d-sm-block d-sm-none">
                            <thead>
                                <tr>
                                    <th>Full Name</th>
                                    <th>Ghana Card Number</th>
                                    <th>Gender</th>
                                    <th>Ownership/Shareholding %</th>
                                    <th>Nationality</th>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {shareholdings!== undefined &&  shareholdings.length>0 && shareholdings.map((share,idx) => (
                                <tr>
                                    <td>{share.name}</td>
                                    <td>{share.ghcardnum}</td>
                                    <td>{formatGender(share.gender, share)}</td>
                                    <td className="text-right">{curformat.format(share.share)}</td>
                                    <td>{formatNationality(share.nationality, share)}</td>
                                    <td><FontAwesomeIcon icon={faEdit} size="lg" className="text-primary"  style={{cursor:'pointer'}} onClick={() => editShareholder(share, idx)} /></td>
                                    <td><FontAwesomeIcon icon={faTrashAlt} size="lg" className="text-danger"  style={{cursor:'pointer'}} onClick={() => deleteShareholder(idx)} /></td>
                                    
                                </tr>
                                ))}
                            </tbody>
                        </table>
                        <div className="d-lg-none d-md-none d-sm-none">
                        {shareholdings!== undefined &&  shareholdings.length>0 && shareholdings.map((share,idx) => (
                        <ul style={{listStyle:'none'}}>
                            <li>Name: <span className="text-primary">{share.name}</span></li>
                            <li>Ghana Card Number: <span className="text-primary">{share.ghcardnum}</span></li>
                            <li>Gender: <span className="text-primary">{formatGender(share.gender, share)}</span></li>
                            <li>Share %: <span className="text-primary">{curformat.format(share.share)}</span></li>
                            <li>Nationality: <span className="text-primary">{formatNationality(share.nationality, share)}</span></li>
                            <li><FontAwesomeIcon icon={faTrashAlt} size="lg" className="text-danger"  style={{cursor:'pointer'}} onClick={() => deleteShareholder(idx)} /></li>
                        </ul>))}
                        </div>
                        
                    </div>
                    <div className="col-xs-12 col-md-6">
                        {shareholdings.length>0 && <div className="form-group">
                            <label for="idcard1image">Upload Majority Shareholder's ID Card:</label><span className="required">*</span>
                            <br /> <small className="text-primary"></small>
                            <div onClick={() => clickTrigger("idcard1image")} className="border border-primary text-center p-1" style={{cursor:'pointer',minHeight:'120px'}}>
                            {businessDetails.idcard1image === '' ? 'Click here to add' : 
                                (![undefined,null].includes(businessDetails.idcard1image) && (businessDetails.idcard1image).includes('pdf')) 
                                ? <FontAwesomeIcon icon={faFilePdf} style={{fontSize:'120px'}} />
                                :(![undefined,null].includes(businessDetails.idcard1image) && (businessDetails.idcard1image).includes('docx'))
                                ? <FontAwesomeIcon icon={faFileWord} style={{fontSize:'120px'}} />
                                : <img src={(doc1.fileUrl !== '') ? doc1.fileUrl : (businessDetails.idcard1image !== null) ? `${BaseURL()}static/${businessDetails.idcard1image}`:``} style={{height:'120px'}} /> }
                            </div>
                            <input type="file" className="form-control" accept=".jpg, .jpeg, .png" id="idcard1image" name="idcard1image" style={{display:'none'}} 
                            onChange={fileChange} />
                        <small className="text-primary">Acceptable upload format: <b>jpeg, jpg, or png</b></small>    
                        </div>}  
                        </div>
                        <div className="col-xs-12 col-md-6">
                        {count == 2 && <div className="form-group">
                            <label for="idcard2image">Upload Second Majority Shareholder's ID Card:</label><span className="required">*</span>
                            <br /> <small className="text-primary"></small>
                            <div onClick={() => clickTrigger("idcard2image")} className="border border-primary text-center p-1" style={{cursor:'pointer',minHeight:'120px'}}>
                            {businessDetails.idcard2image === '' ? 'Click here to add' : 
                                (![undefined,null].includes(businessDetails.idcard2image) && (businessDetails.idcard2image).includes('pdf')) 
                                ? <FontAwesomeIcon icon={faFilePdf} style={{fontSize:'120px'}} />
                                :(![undefined,null].includes(businessDetails.idcard2image) && (businessDetails.idcard2image).includes('docx'))
                                ? <FontAwesomeIcon icon={faFileWord} style={{fontSize:'120px'}} />
                                : <img src={(doc2.fileUrl !== '') ? doc2.fileUrl : (businessDetails.idcard2image !== null) ? `${BaseURL()}static/${businessDetails.idcard2image}`:``} style={{height:'120px'}} /> }
                            </div>
                            <input type="file" className="form-control" accept=".jpg, .jpeg, .png" id="idcard2image" name="idcard2image" style={{display:'none'}} 
                            onChange={fileChange} />
                         <small className="text-primary">Acceptable upload format: <b>jpeg, jpg, or png</b></small>   
                        </div>} 
                        </div>
                </div>
            </form>
            <button className="btn btn-bg btn-outline text-white" style={{ padding: '10px 20px', borderRadius: '20px', marginTop: '25px' }} onClick={() => props.doNavigate(props,1,0)}><FontAwesomeIcon icon={faCaretLeft} size="lg" /> &nbsp; Go Back </button>
            <button type="submit" form="frmShareholding" className="btn btn-bg btn-outline text-white float-right" style={{ padding: '10px 20px', borderBottomRightRadius: '20px', borderTopRightRadius: '20px', marginTop: '25px' }}>Save &amp; Next &nbsp; <FontAwesomeIcon icon={faCaretRight} size="lg" /></button>
            <button type="submit" form="frmShareholding" onClick={()=>setSave(true)} className="btn btn-bg btn-outline text-white float-right" style={{ padding: '10px 20px', borderBottomLeftRadius: '20px', borderTopLeftRadius: '20px', marginRight: '5px', marginTop: '25px' }}>Save &amp; Close &nbsp; <FontAwesomeIcon icon={faSave} size="lg" /></button>

            <div className={modalstatus === true ? "modal fade show d-block" : "modal fade"} arial-hidden="true" style={{zIndex:'1000000000000', overflowY: 'auto'}}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">{shareData.name ? 'Add Shareholder': 'Edit Shareholder'}</h5>
                        </div>
                        <div className="modal-body">
                            <form id="frmNewShare" onSubmit={saveShareholder}>
                                <label htmlFor="floatingInput">Full Name:</label>
                                <div className="form-floating mb-3">
                                    <input type="text" className="form-control" id="name" name="name" placeholder="Full Name" required 
                                    onChange={handleShares} value={shareData.name}/>
                                </div>

                                <label htmlFor="floatingInput">Ghana Card Number:</label>
                                <div className="form-floating mb-3">
                                    <input type="text" className="form-control" id="ghcardnum" name="ghcardnum" placeholder="Ghana Card Number" required 
                                    onChange={handleShares} value={shareData.ghcardnum} onBlur={(e) => CardDuplicateCheck(e, businessDetails.app_num)} />
                                </div>

                                <label htmlFor="floatingInput">Gender:</label>
                                <div className="form-floating mb-3">
                                    <select className="form-control custom-select" id="gender" name="gender" required 
                                        onChange={handleShares} value={shareData.gender}>
                                        <option value=""> -- Choose Gender -- </option>
                                        {dropdowns.gender.map(gend => (
                                            <option value={gend.ivalue}>{gend.iname}</option>
                                        ))}
                                    </select>
                                </div>

                                <label htmlFor="floatingPassword">Ownership/Shareholding Percentage:</label>
                                <div className="form-floating">
                                    <input type="number" min="0" step="any" className="form-control" id="share" name="share" placeholder="Shareholding Percentage" 
                                    onChange={handleShares} value={shareData.share}/>
                                    <small>Total (must sum up to 100%)</small>
                                </div>

                                <label htmlFor="floatingInput">Nationality:</label>
                                <div className="form-floating mb-3">
                                    <select className="form-control custom-select" id="nationality" name="nationality" required 
                                        onChange={handleShares} value={shareData.nationality}>
                                        <option value=""> -- Choose Nationality -- </option>
                                        {dropdowns.nationality.map(gend => (
                                            <option value={gend.ivalue}>{gend.iname}</option>
                                        ))}
                                    </select>
                                </div>

                                {/* <label htmlFor="idcardimage">Upload ID Card</label>
                                <br /> <small className="text-primary">You can upload only images(JPG, JPEG, PNG)</small>
                                <div className="form-floating">
                                    <div id="shareCertCon" className="border border-primary text-center p-1" style={{cursor:'pointer',minHeight:'120px'}}>
                                        {shareData.idcardimage === '' ? 'Click here to add' : 
                                        (![undefined,null].includes(shareData.idcardimage) && (shareData.idcardimage).includes('pdf')) 
                                        ? <FontAwesomeIcon icon={faFilePdf} style={{fontSize:'120px'}} />
                                        : <img src={image.length>0 && image[image.length-1].imageUrl} style={{height:'120px'}} /> }
                                    </div>
                                    <input type="file" className="form-control" accept=".jpg, .jpeg, .png" id="idcardimage" name="cert" style={{display:'none'}}
                                    onChange={imageChange} />
                                </div> */}
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="submit" form="frmNewShare" className="btn btn-primary">Submit</button>
                            <a onClick={hideDialog} className="btn btn-secondary">Cancel</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Shareholder;
